export default __webpack_public_path__ + "static/media/ActiveDigest.268a183d.svg";